import DynamicAdapt from "../../scripts/files/dynamic_adapt.js";
import Utils from "../../scripts/files/utils.js";

export default function Header(){
    new DynamicAdapt('min').init();

    const utils = new Utils();
    let contactsOpenBtns = document.querySelectorAll('[data-contacts-mobile="open"]');
    let contactsPopup = document.querySelector('[data-contacts-mobile="popup"]');
    let body = document.body;
    if (contactsOpenBtns.length > 0 && contactsPopup) {
        contactsOpenBtns.forEach(contactsOpenBtn => {
            contactsOpenBtn.addEventListener('click', function (e) {
                contactsPopup.classList.toggle('contacts-mobile--open');
                contactsOpenBtn.classList.toggle('active');
                e.preventDefault();
            });
            body.addEventListener('click', function (e) {
                if (!e.target.closest('.contacts-mobile') && !e.target.closest('[data-contacts-mobile="open"]')) {
                    contactsPopup.classList.remove('contacts-mobile--open');
                    contactsOpenBtn.classList.remove('active');
                }
            });
        });
    }

    let header = document.querySelector('.header');

    window.addEventListener('scroll', () => {
        header.classList.toggle('header--is-scroll', window.pageYOffset > 0);
    })
}